import React from 'react';

/**
 * Aviso quando a consulta voltou no teto da API (amostra, não o total).
 */
export default function TruncationNotice({
  loaded,
  requestedLimit,
  className = '',
}) {
  const limit = Number(requestedLimit);
  const count = Number(loaded);
  if (!limit || !count || count < limit) return null;
  return (
    <p
      className={`rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 ${className}`}
      role="status"
    >
      A lista mostra os primeiros {limit} registros. Refine a busca ou os filtros
      para ver o restante.
    </p>
  );
}
